import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5001/api',
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to attach auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('adminToken');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor for error handling
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('adminToken');
      window.location.href = '/admin/login';
    }
    return Promise.reject(error);
  }
);

// Auth
export const login = (credentials) => api.post('/auth/login', credentials);
export const getMe = () => api.get('/auth/me');

// Mosques
export const getMosques = () => api.get('/mosques');
export const getMosque = (id) => api.get(`/mosques/${id}`);
export const createMosque = (formData) =>
  api.post('/mosques', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
export const updateMosque = (id, formData) =>
  api.put(`/mosques/${id}`, formData, { headers: { 'Content-Type': 'multipart/form-data' } });
export const deleteMosque = (id) => api.delete(`/mosques/${id}`);

// Prayer Times
export const getTodayPrayerTimes = () => api.get('/prayer-times/today');
export const getPrayerTimesByDate = (date) => api.get(`/prayer-times/date/${date}`);
export const getPrayerTimesByMosque = (mosqueId) => api.get(`/prayer-times/mosque/${mosqueId}`);
export const createPrayerTime = (data) => api.post('/prayer-times', data);
export const updatePrayerTime = (id, data) => api.put(`/prayer-times/${id}`, data);
export const deletePrayerTime = (id) => api.delete(`/prayer-times/${id}`);

// Global Prayer Times
export const getGlobalTimesToday = () => api.get('/global-times/today');
export const getGlobalTimesByDate = (date) => api.get(`/global-times/date/${date}`);
export const getGlobalTimes = () => api.get('/global-times');
export const saveGlobalTime = (data) => api.post('/global-times', data);
export const deleteGlobalTime = (id) => api.delete(`/global-times/${id}`);

// Jummah Times
export const getJummahTimes = () => api.get('/jummah');
export const createJummahTime = (data) => api.post('/jummah', data);
export const updateJummahTime = (id, data) => api.put(`/jummah/${id}`, data);
export const deleteJummahTime = (id) => api.delete(`/jummah/${id}`);

export default api;
